<style scoped>
  .hold-customer-selector {
    display: inline-block;
  }
</style>
<template>
  <div>
    <VModal
      v-model="pass_config.modal"
      :title="pass_modal_title"
      width="500"
      persistent
      :loading="pass_config.loading"
      ok-text="确定"
      @ok="pass"
    >
      <div class="line">
        <div class="line">
          设置备注:
        </div>
        <i-input
          v-model="edit_node_user.comment"
          type="textarea"
          placeholder="备注你的审批意见(可选)"
        />
      </div>
      <div class="hr" />
      <div
        v-if="pass_config.modal && user_flow.id"
        class="line"
      >
        <UserFlow :user_flow="user_flow" />
      </div>
      <Spin
        v-if="loading"
        fix
      />
    </VModal>
    <VModal
      v-model="fail_config.modal"
      :title="fail_modal_title"
      width="500"
      persistent
      :loading="fail_config.loading"
      ok-text="确定"
      @ok="fail"
    >
      <div
        v-if="!cur_flow_node.reject_type"
        class="line"
      >
        <div class="line">
          选择驳回节点:
        </div>
        <Select
          v-model="reject_flow_node_id"
          placeholder="请选择节点"
        >
          <Option
            v-for="flow_node in reject_flow_nodes"
            :key="flow_node.id"
            :value="flow_node.id"
            :label="flow_node.name"
          />
        </Select>
      </div>
      <div class="line">
        <div class="line">
          备注原因:
        </div>
        <i-input
          v-model="edit_node_user.comment"
          type="textarea"
          placeholder="备注你的驳回原因"
        />
      </div>
      <div class="hr" />
      <div
        v-if="fail_config.modal && user_flow.id"
        class="line"
      >
        <UserFlow :user_flow="user_flow" />
      </div>
      <Spin
        v-if="loading"
        fix
      />
    </VModal>

    <VModal
      v-model="invite_config.modal"
      :title="invite_modal_title"
      width="500"
      persistent
      :loading="invite_config.loading"
      ok-text="确定"
      @ok="invite"
    >
      <div class="line">
        <div v-if="invitee.id">
          邀请:
          <span class="text-large">{{ invitee.account }}</span>
          <span class="text-large">[{{ invitee.uid }}]</span>
          <span class="text-large">[{{ invitee.team_name || '未设置团队' }}]</span>
          加入审核.
        </div>
        <div
          v-else
          class="text-large"
        >
          请选择你要邀请的员工!
        </div>
      </div>
      <div class="line">
        <i-input
          v-model="search_customer_text"
          @on-enter="searchCustomer"
        >
          <span slot="prepend">搜索员工</span>
          <Button
            slot="append"
            :loading="searching"
            @click="searchCustomer"
          >
            确定
          </Button>
        </i-input>
        <div class="line">
          <Button
            v-for="customer in search_customer_results"
            :key="customer.id"
            size="small"
            :style="{margin: '3px'}"
            :disabled="customer.id === edit_node_user.customer_id"
            @click="setInvitee(customer)"
          >
            <span>{{ customer.account }} - </span>
            <span>{{ customer.uid }} - </span>
            <span>{{ customer.team_name || '未设置团队' }}</span>
          </Button>
        </div>
      </div>
      <div class="hr" />
      <div class="line">
        <div class="line text-bold">
          邀请原因:
        </div>
        <i-input
          v-model="invite_reason"
          type="textarea"
          placeholder="备注你邀请的原因"
        />
      </div>
      <div class="hr" />
      <div
        v-if="invite_config.modal && user_flow.id"
        class="line"
      >
        <UserFlow :user_flow="user_flow" />
      </div>
      <Spin
        v-if="loading"
        fix
      />
    </VModal>

    <VModal
      v-model="transfer_config.modal"
      :title="transfer_modal_title"
      width="500"
      persistent
      :loading="transfer_config.loading"
      ok-text="确定"
      @ok="transfer"
    >
      <div class="line">
        <div v-if="transferee.id">
          转移审核权限给:
          <span class="text-large">{{ transferee.account }}</span>
          <span class="text-large">[{{ transferee.uid }}]</span>
          <span class="text-large">[{{ transferee.team_name || '未设置团队' }}]</span>
        </div>
        <div
          v-else
          class="text-large"
        >
          转移审核权限给其他员工!
        </div>
      </div>
      <div class="line">
        <i-input
          v-model="search_customer_text"
          @on-enter="searchCustomer"
        >
          <span slot="prepend">搜索员工</span>
          <Button
            slot="append"
            :loading="searching"
            @click="searchCustomer"
          >
            确定
          </Button>
        </i-input>
        <div class="line">
          <Button
            v-for="customer in search_customer_results"
            :key="customer.id"
            size="small"
            :style="{margin: '3px'}"
            :disabled="customer.id === edit_node_user.customer_id"
            @click="setTransferee(customer)"
          >
            <span>{{ customer.account }} - </span>
            <span>{{ customer.uid }} - </span>
            <span>{{ customer.team_name || '未设置团队' }}</span>
          </Button>
        </div>
      </div>
      <div class="hr" />
      <div class="line">
        <div class="line text-bold">
          转移原因:
        </div>
        <i-input
          v-model="transfer_reason"
          type="textarea"
          placeholder="备注你转移的原因"
        />
      </div>
      <div class="hr" />
      <div
        v-if="transfer_config.modal && user_flow.id"
        class="line"
      >
        <UserFlow :user_flow="user_flow" />
      </div>
      <Spin
        v-if="loading"
        fix
      />
    </VModal>

    <VModal
      v-model="hold_config.modal"
      :title="hold_modal_title"
      width="500"
      persistent
      :loading="hold_config.loading"
      ok-text="确定"
      @ok="hold"
    >
      <div class="line">
        <div class="line">
          临时节点名称 <span class="color-error">*</span>
        </div>
        <i-input
          v-model="hold_params.temp_node_name"
          :maxlength="20"
          placeholder="临时节点名称..."
        />
        <div class="hr" />
        <div class="line">
          临时节点人员 <span class="color-error">*</span>
        </div>
        <div
          class="line"
        >
          <CustomerSelector
            v-if="hold_config.modal"
            clearable
            @change="addHoldCustomer"
          />
          <Tag
            v-for="(customer, index) in hold_params.customers"
            :key="customer.id"
            type="border"
            closable
            @on-close="delHoldCustomer(index)"
          >
            {{ customer.account }}
          </Tag>
        </div>
        <div class="hr" />
        <div class="line">
          临时节点完成后返回至 <span class="color-error">*</span>
        </div>
        <Select
          v-model="hold_params.return_flow_node_id"
          placeholder="请选择节点"
        >
          <Option :value="cur_flow_node.id">
            {{ cur_flow_node.name }}(当前节点)
          </Option>
          <Option
            v-for="flow_node in reject_flow_nodes"
            :key="flow_node.id"
            :value="flow_node.id"
            :label="flow_node.name"
          />
        </Select>
        <div class="hr" />
        <div class="line">
          备注原因(可选)
        </div>
        <i-input
          v-model="hold_params.reason"
          type="textarea"
          placeholder="备注..."
        />
      </div>
      <div class="hr" />
      <div
        v-if="hold_config.modal && user_flow.id"
        class="line"
      >
        <UserFlow :user_flow="user_flow" />
      </div>
      <Spin
        v-if="loading"
        fix
      />
    </VModal>

    <VModal
      v-model="link_config.modal"
      :title="link_modal_title"
      width="500"
      persistent
      :loading="link_config.loading"
      ok-text="确定"
      @ok="link"
    >
      <div class="line">
        <div class="line">
          抄送人员 <span class="color-error">*</span>
        </div>
        <div class="line">
          <CustomerSelector
            v-if="link_config.modal"
            v-model="link_params.customer_id"
            clearable
            @change="addLinkCustomer"
          />
          <Tag
            v-for="(customer, index) in link_params.customers"
            :key="customer.id"
            type="border"
            closable
            @on-close="delLinkCustomer(index)"
          >
            {{ customer.account }}
          </Tag>
        </div>
        <div class="hr" />
        <div class="line">
          <Checkbox v-model="link_params.notice" />
          通知抄送人
        </div>
      </div>
      <Spin
        v-if="loading"
        fix
      />
    </VModal>

    <VModal
      v-model="show_config.modal"
      title="流程详情"
      width="500"
      cancel-text=""
      persistent
      @ok="show_config.modal = false"
    >
      <Spin
        v-if="loading"
        fix
      />
      <UserFlow
        v-if="!loading && user_flow.id"
        :user_flow="user_flow"
      />
    </VModal>
  </div>
</template>
<script>
  import FlowUtil from '../../../libs/flow_util';
  import UserFlow from './user_flow';
  import CustomerSelector from '../customer/v-selector';
  import VModal from '../../../vuetify_custom/v-modal';

  const DEFAULT_HOLD_PARAMS = {
    temp_node_name: '',
    customers: [],
    reason: '',
    return_flow_node_id: ''
  }

  const DEFAULT_LINK_PARAMS = {
    customer_id: 0,
    user_flow_id: 0,
    customers: [],
    notice: true
  }

  export default {
    components: { VModal, UserFlow, CustomerSelector },
    data() {
      return {
        loading: false,
        user_flow: {},
        show_config: {modal: false},
        pass_config: {modal: false, loading: true},
        fail_config: {modal: false, loading: true},
        invite_config: {modal: false, loading: true},
        transfer_config: {modal: false, loading: true},
        hold_config: {modal: false, loading: true},
        link_config: {modal: false, loading: true},
        edit_node_user: {comment: ''},
        // 驳回节点的id
        reject_flow_node_id: '',
        // 被邀请的人
        invitee: {},
        invite_reason: '',
        search_customer_text: '',
        search_customer_results: [],
        searching: false,
        transferee: {},
        transfer_reason: '',
        hold_params: this.$util.clone(DEFAULT_HOLD_PARAMS),
        link_params: this.$util.clone(DEFAULT_LINK_PARAMS)
      }
    },
    computed: {
      pass_modal_title() {
        const action_type = this.edit_node_user.action_type;
        if (action_type) {
          const pass_text = this.getPassText(action_type);
          return `你确定要 ${pass_text} 吗?`;
        } else {
          return '';
        }
      },
      fail_modal_title() {
        return '你确定要 驳回 吗?';
      },
      invite_modal_title() {
        return '邀请员工加入审核.';
      },
      transfer_modal_title() {
        return '转移至其他员工.';
      },
      hold_modal_title() {
        return '转移至临时节点';
      },
      link_modal_title() {
        return '添加抄送人员';
      },
      // 可驳回节点
      reject_flow_nodes() {
        const nodes = [];
        const hash = {};
        this.user_flow.user_flow_nodes.forEach((ufn) => {
          // 节点去重
          const not_in_list = !hash[ufn.flow_node_id];
          // 不能驳回至当前节点
          const not_cur_node = this.cur_flow_node.id !== ufn.flow_node_id;
          /*
          * return_flow_node_id = 0 为正常节点
          * return_flow_node_id > 0 为临时节点
          * 不能驳回至临时节点
          */
          const not_tmp_node = ufn.return_flow_node_id === 0;
          if (not_in_list && not_cur_node && not_tmp_node) {
            hash[ufn.flow_node_id] = true;
            const node = { id: ufn.flow_node_id, name: ufn.flow_node_name };
            nodes.push(node);
          }
        });
        return nodes;
      },
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      cur_user_node() {
        const cur = this.user_flow.user_flow_nodes[0];
        return cur || {};
      },
      cur_flow_node() {
        const cur = this.nodes_hash[this.cur_user_node.flow_node_id];
        return cur || {id: 0};
      },
      cur_node_name() {
        return this.cur_flow_node.name;
      },
      cur_node_desc() {
        return this.cur_flow_node.desc;
      },
      nodes_hash() {
        const hash = {};
        this.user_flow.user_flow_nodes.forEach((user_flow_node) => {
          const node = user_flow_node.flow_node;
          hash[node.id] = node;
        });
        return hash;
      },
    },
    created() {
      this.resetUserFlow();
      this.addEventListener();
    },
    mounted() {
      //
    },
    beforeDestroy() {
      this.removeEventListener();
    },
    methods: {
      addEventListener() {
        window.eventHub.$on('show-user-flow-handler', this.eventHandler);
        window.eventHub.$on('show-user-flow', this.showUserFlow);
        window.eventHub.$on('show-add-link-user', this.showAddLinkUser);
      },
      removeEventListener() {
        window.eventHub.$off('show-user-flow-handler', this.eventHandler);
        window.eventHub.$off('show-user-flow', this.showUserFlow);
        window.eventHub.$off('show-add-link-user', this.showAddLinkUser);
      },
      eventHandler(type, user_flow_id, user_flow_node_user) {
        this[`${type}_config`].modal = true;
        // reset info
        this.resetUserFlow();
        this.reject_flow_node_id = '';
        this.invitee = {};
        this.invite_reason = '';
        this.transferee = {};
        this.transfer_reason = '';
        this.hold_params = this.$util.clone(DEFAULT_HOLD_PARAMS);
        this.edit_node_user = this.$util.clone(user_flow_node_user);
        // 获取流程数据
        this.loading = true;
        FlowUtil.getUserFlowInfo(user_flow_id).then((user_flow) => {
          this.user_flow = user_flow;
          this.setDefaultReturnFlowNode();
        }).catch(() => {
          this.$Message.error({content: '获取流程信息失败', duration: 2.5});
        }).finally(() => {
          this.loading = false;
        });
      },
      showUserFlow(user_flow_id) {
        this.show_config.modal = true;
        this.loading = true;
        FlowUtil.getUserFlowInfo(user_flow_id).then((user_flow) => {
          this.user_flow = user_flow;
        }).catch(() => {
          this.$Message.error({content: '获取流程信息失败', duration: 2.5});
        }).finally(() => {
          this.loading = false;
        });
      },
      showAddLinkUser(user_flow_id) {
        this.link_params = this.$util.clone(DEFAULT_LINK_PARAMS);
        this.link_params.user_flow_id = user_flow_id;
        this.link_config.modal = true;
      },
      resetUserFlow() {
        this.user_flow = {user_flow_nodes: []};
      },
      pass() {
        this.$util.ajax.post(this.$util.api.pass_user_flow_node_user, this.edit_node_user).then((response) => {
          return response.data;
        }).then((data) => {
          if (data.user_flow) {
            this.emitUpdateEvents(data.user_flow);
          }
          if (data.code === 1 || data.code === 2) {
            this.pass_config.modal = false;
          } else {
            this.$Modal.error({title: '提示', content: data.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '错误', content: `${e.message}, 请重试`});
        }).finally(() => {
          this.resetLoading(this.pass_config);
        });
      },
      checkFailValid() {
        if (this.cur_user_node.flow_node.reject_type === 1) {
          const prev_user_flow_node = this.user_flow.user_flow_nodes.find(user_flow_node => user_flow_node.id === this.cur_user_node.prev_id)
          this.reject_flow_node_id = prev_user_flow_node.flow_node.id
        }
        let msg = '';
        if (!this.reject_flow_node_id) {
          msg += `<p>请选择驳回节点!</p>`;
        }
        if (!this.edit_node_user.comment) {
          msg += `<p>请输入你驳回的原因!</p>`;
        }
        if (msg) {
          this.$Modal.error({
            title: '错误',
            content: msg
          });
          this.resetLoading(this.fail_config);
          return false;
        }
        return true;
      },
      fail() {
        if (!this.checkFailValid()) return;
        this.$util.ajax.post(this.$util.api.fail_user_flow_node_user, {
          id: this.edit_node_user.id,
          user_flow_id: this.user_flow.id,
          comment: this.edit_node_user.comment,
          reject_flow_node_id: this.reject_flow_node_id
        }).then((response) => {
          return response.data;
        }).then((data) => {
          if (data.user_flow) {
            this.emitUpdateEvents(data.user_flow);
          }
          if (data.code === 1) {
            this.fail_config.modal = false;
          } else {
            this.$Modal.error({title: '提示', content: data.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '错误', content: `${e.message}, 请重试`});
        }).finally(() => {
          this.resetLoading(this.fail_config);
        });
      },
      checkInviteValid() {
        let msg = '';
        if (!this.invitee.id) {
          msg += `<p>请设置你要邀请的人!</p>`;
        }
        if (!this.invite_reason) {
          msg += `<p>请输入你邀请的原因!</p>`;
        }
        if (msg) {
          this.$Modal.error({
            title: '错误',
            content: msg
          });
          this.resetLoading(this.invite_config);
          return false;
        }
        return true;
      },
      invite() {
        if (!this.checkInviteValid()) return;
        this.$util.ajax.post(this.$util.api.invite_user_flow_node_user, {
          id: this.edit_node_user.id,
          invitee_id: this.invitee.id,
          invite_reason: this.invite_reason
        }).then((response) => {
          return response.data;
        }).then((data) => {
          if (data.user_flow) {
            this.emitUpdateEvents(data.user_flow);
          }
          if (data.code === 1) {
            this.invite_config.modal = false;
          } else {
            this.$Modal.error({title: '提示', content: data.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '错误', content: `${e.message}, 请重试`});
        }).finally(() => {
          this.resetLoading(this.invite_config);
        });
      },
      checkTransferValid() {
        let msg = '';
        if (!this.transferee.id) {
          msg += `<p>请设置你要转移的人!</p>`;
        }
        if (!this.transfer_reason) {
          msg += `<p>请输入你转移的原因!</p>`;
        }
        if (msg) {
          this.$Modal.error({
            title: '错误',
            content: msg
          });
          this.resetLoading(this.transfer_config);
          return false;
        }
        return true;
      },
      transfer() {
        if (!this.checkTransferValid()) return;
        this.$util.ajax.post(this.$util.api.transfer_user_flow_node_user, {
          id: this.edit_node_user.id,
          transferee_id: this.transferee.id,
          transfer_reason: this.transfer_reason
        }).then((response) => {
          return response.data;
        }).then((data) => {
          if (data.user_flow) {
            this.emitUpdateEvents(data.user_flow);
          }
          if (data.code === 1) {
            this.transfer_config.modal = false;
          } else {
            this.$Modal.error({title: '提示', content: data.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '错误', content: `${e.message}, 请重试`});
        }).finally(() => {
          this.resetLoading(this.transfer_config);
        });
      },
      checkHoldValid() {
        let msg = '';
        if (!this.hold_params.temp_node_name.trim()) {
          msg += `<p>请填写临时节点的名称</p>`;
        }
        if (!this.hold_params.customers.length) {
          msg += `<p>请至少选择一个节点人员</p>`;
        }
        if (!this.hold_params.return_flow_node_id) {
          msg += `<p>请选择返回节点</p>`;
        }
        if (msg) {
          this.$Modal.error({
            title: '错误',
            content: msg
          });
          this.resetLoading(this.hold_config);
          return false;
        }
        return true;
      },
      hold() {
        if (!this.checkHoldValid()) return;
        this.$util.ajax.post(this.$util.api.hold_user_flow_node_user, {
          id: this.edit_node_user.id,
          reason: this.hold_params.reason,
          return_flow_node_id: this.hold_params.return_flow_node_id,
          temp_node_name: this.hold_params.temp_node_name,
          temp_node_user_ids: this.hold_params.customers.map((c) => c.id)
        }).then((response) => {
          return response.data;
        }).then((data) => {
          if (data.user_flow) {
            this.emitUpdateEvents(data.user_flow);
          }
          if (data.code === 1) {
            this.hold_config.modal = false;
          } else {
            this.$Modal.error({title: '提示', content: data.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '错误', content: `${e.message}, 请重试`});
        }).finally(() => {
          this.resetLoading(this.hold_config);
        });
      },
      checkLinkValid() {
        let msg = '';
        if (!this.link_params.customers.length) {
          msg += `<p>请至少选择一个抄送人员</p>`;
        }
        if (msg) {
          this.$Modal.error({title: '错误', content: msg});
          this.resetLoading(this.link_config);
          return false;
        }
        return true;
      },
      link() {
        if (!this.checkLinkValid()) return;
        this.$util.ajax.post(this.$util.api.add_user_flow_link_user, {
          id: this.link_params.user_flow_id,
          customer_ids: this.link_params.customers.map((c) => c.id),
          notice: this.link_params.notice
        }).then((response) => {
          return response.data;
        }).then((res) => {
          const data = res.data;
          if (data.user_flow) {
            this.emitUpdateEvents(data.user_flow);
          }
          if (res.code === 1) {
            this.link_config.modal = false;
          } else {
            this.$Modal.error({title: '提示', content: data.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '错误', content: `${e.message}, 请重试`});
        }).finally(() => {
          this.resetLoading(this.link_config);
        });
      },
      resetLoading(config) {
        config.loading = false;
        setTimeout(() => {
          config.loading = true;
        }, 500);
      },
      setDefaultReturnFlowNode() {
        this.hold_params.return_flow_node_id = this.cur_flow_node.id;
      },
      addHoldCustomer(customer) {
        if (!customer.id) return;
        const customers = this.hold_params.customers;
        for (let i = 0, len = customers.length; i < len; i++) {
          if (customers[i].id === customer.id) return;
        }
        this.hold_params.customers.push(customer);
      },
      delHoldCustomer(index) {
        this.hold_params.customers.splice(index, 1);
      },
      addLinkCustomer(customer) {
        if (!customer.id) return;
        const customers = this.link_params.customers;
        const len = customers.length;
        for (let i = 0; i < len; i++) {
          if (customers[i].id === customer.id) return;
        }
        this.link_params.customers.push(customer);
      },
      delLinkCustomer(index) {
        this.link_params.customers.splice(index, 1);
      },
      emitUpdateEvents(user_flow) {
        window.eventHub.$emit(`update-user-flow-base-${user_flow.id}`);
        window.eventHub.$emit(`update-user-flow-${user_flow.id}`, user_flow);
      },
      getPassText(action_type) {
        return FlowUtil.getPassText(action_type);
      },
      searchCustomer() {
        if (this.searching) return;
        this.searching = true;
        this.$util.ajax.get(this.$util.api.query_customer_with_team, {
          params: {
            search: this.search_customer_text,
            customer_type: 'all'
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          this.search_customer_results = [];
          if (res.code === 1) {
            const data = res.data;
            data.forEach((customer) => {
              this.search_customer_results.push(customer);
            });
          } else {
            this.$Modal.error({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '错误', content: `${e.message}, 请重试`});
        }).finally(() => {
          this.searching = false;
        });
      },
      setInvitee(invitee) {
        this.invitee = invitee;
      },
      setTransferee(transferee) {
        this.transferee = transferee;
      }
    }
  }
</script>
